import React, { useState } from 'react';
import { 
  FaQuoteLeft, 
  FaStar, 
  FaMapMarkerAlt, 
  FaUniversity,
  FaChevronLeft,
  FaChevronRight,
  FaGraduationCap,
  FaGlobeAfrica
} from 'react-icons/fa';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Chantal M.",
      origin: "Cameroun",
      city: "Lyon",
      school: "Université Lumière Lyon 2",
      program: "Master en Commerce International",
      text: "Grâce à BTG CONSEIL, j'ai intégré une école à Lyon et trouvé un logement en 10 jours. Leur accompagnement a été exceptionnel !",
      rating: 5,
      color: '#073b8f'
    },
    {
      id: 2,
      name: "Jean K.",
      origin: "Côte d'Ivoire",
      city: "Paris",
      school: "ESG Management School",
      program: "MBA en Finance",
      text: "BTG CONSEIL a rendu ma procédure simple et rapide. Mon visa a été obtenu en moins d'un mois grâce à leur expertise.",
      rating: 5,
      color: '#c0264a'
    },
    {
      id: 3,
      name: "Aïcha D.",
      origin: "Sénégal",
      city: "Toulouse",
      school: "INSA Toulouse",
      program: "Ingénieur en Informatique",
      text: "J'ai eu mon visa sans stress grâce à leur équipe. Leur accompagnement humain fait vraiment la différence.",
      rating: 5,
      color: '#073b8f'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar 
        key={index} 
        className={index < rating ? "btg-star btg-filled" : "btg-star"} 
      />
    ));
  };

  return (
    <section className="btg-testimonials-section-light" id="btg-temoignages">
      <div className="btg-container-light">
        {/* En-tête simplifié */}
        <div className="btg-testimonials-header-light">
          <h2 className="btg-main-title-light">Ils nous font confiance</h2>
          <p className="btg-subtitle-light">
            Découvrez les expériences de nos étudiants
          </p>
        </div>

        {/* Carousel simplifié */}
        <div className="btg-testimonials-carousel-light">
          <div className="btg-carousel-container-light">
            <button className="btg-carousel-btn-light btg-prev-light" onClick={prevTestimonial}>
              <FaChevronLeft />
            </button>

            <div 
              className="btg-testimonial-card-light"
              style={{ '--btg-accent-color': testimonials[currentTestimonial].color }}
            >
              <div className="btg-quote-section-light">
                <FaQuoteLeft className="btg-quote-icon-light" />
                <p className="btg-testimonial-text-light">
                  "{testimonials[currentTestimonial].text}"
                </p>
                
                <div className="btg-rating-light">
                  {renderStars(testimonials[currentTestimonial].rating)}
                </div>
              </div>

              <div className="btg-student-info-light">
                <div className="btg-student-header-light">
                  <h4>{testimonials[currentTestimonial].name}</h4>
                  <div className="btg-student-origin-light">
                    <FaGlobeAfrica />
                    {testimonials[currentTestimonial].origin}
                  </div>
                </div>
                
                <div className="btg-student-details-light">
                  <div className="btg-detail-item-light">
                    <FaMapMarkerAlt />
                    <span>{testimonials[currentTestimonial].city}</span>
                  </div>
                  <div className="btg-detail-item-light">
                    <FaUniversity />
                    <span>{testimonials[currentTestimonial].school}</span>
                  </div>
                  <div className="btg-detail-item-light">
                    <FaGraduationCap />
                    <span>{testimonials[currentTestimonial].program}</span>
                  </div>
                </div>
              </div>
            </div>

            <button className="btg-carousel-btn-light btg-next-light" onClick={nextTestimonial}>
              <FaChevronRight />
            </button>
          </div>

          {/* Indicateurs simplifiés */}
          <div className="btg-carousel-indicators-light">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`btg-indicator-light ${index === currentTestimonial ? 'btg-active-light' : ''}`}
                onClick={() => goToTestimonial(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;